import React from 'react';

function Dashboard() {
    return (
        <div
            className="relative 2xl:h-screen xl:h-screen lg:h-screen bg-gradient-to-r from-[#0CC8E8] to-[#2DEEAA] flex flex-col items-center 2xl:mb-72 xl:mb-48 lg:mb-28 md:mb-20 mb-16"
        >
            <h1 className="text-[28px] 2xl:text-6xl xl:text-6xl lg:text-6xl md:text-5xl sm:text-3xl font-bold text-black 2xl:mt-10 xl:mt-10 lg:mt-10 md:mt-10 mt-5 mb-5">
                Secure All-in-One Dashboard
            </h1>
            <img src="/dashboard.png" alt="Dashboard" className='2xl:w-11/12 xl:w-11/12 lg:w-11/12 md:w-11/12 sm:w-11/12 w-full' />
        </div>

    );
}

export default Dashboard;
